<template>
  <div class="scroll-animation" :class="{ 'is-visible': visible }" ref="element">
    <slot/>
  </div>
</template>



<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.handleScroll()
  },
  methods: {
    handleScroll() {
      if (!this.visible) {
        let el = this.$refs.element
        let top = el.getBoundingClientRect().top

        if (top < window.innerHeight - window.innerHeight / 5 * 2) {
          this.visible = true
        }
      }
    }
  },
}
</script>



<style lang="scss">
.scroll-animation {
}
</style>
